module.exports = __webpack_public_path__ + "static/diy_recipe_gummy_bears_thumbnail-8e67f68c73339cba41d70a046dfa30b5.jpg";